module.exports = __webpack_public_path__ + "img/logo-qujiao.a1bb6cfd.png";